import React, { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import Gamme from "./pages/Gamme";
import DecouvrirGamme from "./pages/DecouvrirGamme";
import Produit from "./pages/Produit";
import APropos from "./pages/APropos";
import Fabrication from "./pages/Fabrication";
import Contact from "./pages/Contact";
import MerciContact from "./pages/MerciContact";
import MentionsLegales from "./pages/MentionsLegales";
import YonoBrand from "./pages/YonoBrand";
import { gaPageView } from "./lib/analytics";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function GAListener() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Fire on each route change. gtag handles consent — denied = no cookies.
    const t = setTimeout(() => gaPageView(pathname + search), 50);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <GAListener />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gamme" element={<DecouvrirGamme />} />
          <Route path="/produits" element={<Gamme />} />
          <Route path="/produits/:slug" element={<Produit />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/fabrication" element={<Fabrication />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/merci" element={<MerciContact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/yono" element={<YonoBrand />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
